import React, { useMemo } from 'react';
import { StyledButton, StyledIcon } from './ButtonForRadioList.style';

function ButtonForRadioList({ optionId, settings, onButtonClick, disabled }) {
  const { style } = settings;
  const buttonStyle = useMemo(() => ({
    ...style.button,
    color: style.body.color,
    backgroundColor: style.button.backgroundColor,
  }), [style.button, style.body.color]);

  return (
    <StyledButton
      key={optionId}
      styled={buttonStyle}
      disableFluid
      onClick={onButtonClick}
      aria-label="information"
      disabled={disabled}
    >
      <StyledIcon />
    </StyledButton>
  );
}

ButtonForRadioList.displayName = 'ButtonForRadioList';
export default ButtonForRadioList;
